// The Facility's timezone is the authoritative boundary for Work Order due
// dates, so due-date display must use an explicit `timeZone`
// (matching the backend's due-date filter boundary) instead of the
// browser's local timezone. Consolidates the due-date formatting previously
// duplicated between the Work Orders table and the Work Order detail views.
export function formatWorkOrderDueDate(
  value: string | null,
  timeZone?: string,
): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return "—";

  const dateKeyFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const isSameDay =
    dateKeyFormatter.format(date) === dateKeyFormatter.format(new Date());
  const time = new Intl.DateTimeFormat(undefined, {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);

  if (isSameDay) return `Today · ${time}`;

  return new Intl.DateTimeFormat(undefined, {
    timeZone,
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}
